export const CONTAINER_MAX_WIDTH = 1568;
export const CONTAINER_MAX_WIDTH_CSS = `${CONTAINER_MAX_WIDTH}px`;

export const CONTAINER_PADDING_SM_MAX = 8;
export const CONTAINER_PADDING_SM_MIN = 24;
export const CONTAINER_PADDING_SM_MAX_CSS = `${CONTAINER_PADDING_SM_MAX}px`;
export const CONTAINER_PADDING_SM_MIN_CSS = `${CONTAINER_PADDING_SM_MIN}px`;

export const CONTAINER_GRID_COLUMN_NARROW = 300;
export const CONTAINER_GRID_COLUMN_WIDE = 750;
export const CONTAINER_QHD_MIN = 2560;

export const CONTAINER_GRID_COLUMN_NARROW_CSS = `${CONTAINER_GRID_COLUMN_NARROW}px`;
export const CONTAINER_GRID_COLUMN_WIDE_CSS = `${CONTAINER_GRID_COLUMN_WIDE}px`;
export const CONTAINER_QHD_MEDIA = `(min-width: ${CONTAINER_QHD_MIN + 1}px)`;

export const CONTAINER_GRID_COLUMN_FLEX_CSS = 'minmax(0, 1fr)';
export const CONTAINER_GRID_COLUMN_FLEX_WIDE_CSS = `minmax(0, min(${CONTAINER_GRID_COLUMN_WIDE_CSS}, 1fr))`;

export const CONTAINER_GRID_GAP_SM_MAX = 8;
export const CONTAINER_GRID_GAP_SM_MIN = 24;
export const CONTAINER_GRID_GAP_SM_MAX_CSS = `${CONTAINER_GRID_GAP_SM_MAX}px`;
export const CONTAINER_GRID_GAP_SM_MIN_CSS = `${CONTAINER_GRID_GAP_SM_MIN}px`;
